// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"460216da","157":"8b1b772f","496":"e4412ea1","675":"802688e4"}[chunkId] + ".chunk.js";
};